import { Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { UpdatedWorkplace, Workplace as Workplace_1, NewWorkplace, Track_$reflection, Region_$reflection, Workplace_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, int32_type, string_type, record_type, bool_type, option_type, array_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { append as append_1, map as map_1, tryFind, tryHead, contains, equalsWith } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { equals, stringHash, createObj, numberHash, defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";
import { unwrap, bind, toArray as toArray_1, map, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { SkeletonItem, Skeleton, Checkbox, PopoverSurface, PopoverTrigger, Popover, Card, Caption1, Title3, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, createTableColumn as createTableColumn_6, Body1, Body1Strong, tokens, TagPickerList, TagPickerOption, useTagPickerFilter as useTagPickerFilter_1, TagPickerControl, TagPickerInput, TagPickerGroup, Avatar, Tag, TagPicker, DialogBody, DialogActions, Switch, Text as Text$, Option, Dropdown, Input, Field, DialogContent, DialogTitle, DialogSurface, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { ErrorCircleRegular, FilterRegular, SearchRegular, DismissFilled, CheckmarkFilled, PenDismissRegular, WarningFilled, DeleteRegular, SaveRegular, EditRegular, DismissRegular, AddRegular } from "@fluentui/react-icons";
import { take, length, iterate, toArray, tryHead as tryHead_1, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { compare, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf as defaultOf_1 } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { singleton as singleton_1, map as map_2, toArray as toArray_2, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Component } from "./MunicipalitySearch.jsx";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Track, Region, toastServerError, Workplace } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { SortDirection } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Checkbox_toBool } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.29.0/Range.js";

class Model extends Record {
    constructor(Workplaces, Regions, Tracks, IsFetchingWorkplaces, Filter) {
        super();
        this.Workplaces = Workplaces;
        this.Regions = Regions;
        this.Tracks = Tracks;
        this.IsFetchingWorkplaces = IsFetchingWorkplaces;
        this.Filter = Filter;
    }
}

function Model_$reflection() {
    return record_type("Workplaces.Model", [], Model, () => [["Workplaces", option_type(array_type(Workplace_$reflection()))], ["Regions", array_type(Region_$reflection())], ["Tracks", array_type(Track_$reflection())], ["IsFetchingWorkplaces", bool_type], ["Filter", Filter_$reflection()]]);
}

class Filter extends Record {
    constructor(SearchTerm, ShowOnlyEnabled, ShowOnlyFromRegions) {
        super();
        this.SearchTerm = SearchTerm;
        this.ShowOnlyEnabled = ShowOnlyEnabled;
        this.ShowOnlyFromRegions = ShowOnlyFromRegions;
    }
}

function Filter_$reflection() {
    return record_type("Workplaces.Filter", [], Filter, () => [["SearchTerm", string_type], ["ShowOnlyEnabled", bool_type], ["ShowOnlyFromRegions", array_type(int32_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateWorkplaces", "UpdateRegions", "UpdateTracks", "UpdateIsFetching", "UpdateFilter"];
    }
}

function Msg_$reflection() {
    return union_type("Workplaces.Msg", [], Msg, () => [[["Item", option_type(array_type(Workplace_$reflection()))]], [["Item", array_type(Region_$reflection())]], [["Item", array_type(Track_$reflection())]], [["Item", bool_type]], [["Item", Filter_$reflection()]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Workplaces, msg.fields[0], model.Tracks, model.IsFetchingWorkplaces, model.Filter);
        case 2:
            return new Model(model.Workplaces, model.Regions, msg.fields[0], model.IsFetchingWorkplaces, model.Filter);
        case 3:
            return new Model(model.Workplaces, model.Regions, model.Tracks, msg.fields[0], model.Filter);
        case 4:
            return new Model(model.Workplaces, model.Regions, model.Tracks, model.IsFetchingWorkplaces, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Regions, model.Tracks, model.IsFetchingWorkplaces, model.Filter);
    }
}

function init() {
    return new Model(undefined, [], [], true, new Filter("", false, new Int32Array([])));
}

function applyFilter(model, workplace) {
    let isInRegionsToShow;
    const matchValue = model.Filter.ShowOnlyFromRegions;
    isInRegionsToShow = ((!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 0)) ? true : contains(workplace.Region.Id, matchValue, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: numberHash,
    }));
    const searchTerm = model.Filter.SearchTerm.toLocaleLowerCase();
    const workplaceName = workplace.Name.toLocaleLowerCase();
    if ((workplaceName.indexOf(searchTerm) >= 0) && (!model.Filter.ShowOnlyEnabled ? true : workplace.Enabled)) {
        return isInRegionsToShow;
    }
    else {
        return false;
    }
}

function AddWorkplaceDialog(addWorkplaceDialogInputProps) {
    let elems_12, el_4, el_2, el, el_42, elems_11, props_58, el_6, el_30, elems_9, elems_1, el_11, elems_5, el_20, matchValue_1, el_17, elems_3, elems_7, el_23, el_28, matchValue_3, el_25, el_40, elems_10, el_34, el_32, el_38, el_36, name_7, elemsToUse;
    const dispatch = addWorkplaceDialogInputProps.dispatch;
    const model = addWorkplaceDialogInputProps.model;
    const workplaces = addWorkplaceDialogInputProps.workplaces;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    let patternInput_4;
    const initial_3 = new NewWorkplace("", true, defaultArg(map((_arg) => _arg.Id, tryHead(model.Regions)), -1), "");
    patternInput_4 = reactApi.useState(initial_3);
    const setForm = patternInput_4[1];
    const form = patternInput_4[0];
    const resetForm = () => {
        setForm(new NewWorkplace("", true, defaultArg(map((_arg_1) => _arg_1.Id, tryHead(model.Regions)), -1), ""));
    };
    const el_44 = Dialog;
    return createElement(el_44, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_2, value_1_2) => {
        setIsOpen(value_1_2.open);
    }], (elems_12 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            iconPosition: "before",
            appearance: "primary",
            children: "Legg til",
        })),
    })), (el_42 = DialogSurface, createElement(el_42, createObj(ofArray([["style", {
        maxWidth: 400,
    }], (elems_11 = [(props_58 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til arbeidsplass",
    })), (el_30 = DialogContent, createElement(el_30, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_1[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead_1([(el_8 = Input, createElement(el_8, {
            maxLength: 100,
            value: form.Name,
            onChange: (_arg_3, value_1_10) => {
                const v = value_1_10;
                setForm(new NewWorkplace(v.value, form.Enabled, form.RegionId, form.Municipality));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf_1() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_5 = [(el_20 = Field, createElement(el_20, {
        label: "Region",
        children: (matchValue_1 = tryHead_1([(el_17 = Dropdown, createElement(el_17, createObj(ofArray([["style", {
            minWidth: 200,
        }], ["value", defaultArg(map((_arg_4) => _arg_4.Name, tryFind((region) => (region.Id === form.RegionId), model.Regions)), "Ingen valgt")], ["selectedOptions", toArray([defaultArg(map((_arg_5) => _arg_5.Name, tryFind((region_1) => (region_1.Id === form.RegionId), model.Regions)), "Ingen valgt")])], ["onOptionSelect", (_arg_6, value_1_14) => {
            iterate((region_2) => {
                setForm(new NewWorkplace(form.Name, form.Enabled, region_2.Id, form.Municipality));
            }, toArray_1(bind((name_2) => tryFind((r_1) => (r_1.Name === name_2), model.Regions), value_1_14.optionText)));
        }], (elems_3 = toList(delay(() => map_1((region_3) => {
            let elems_2, el_13;
            const el_15 = Option;
            return createElement(el_15, createObj(ofArray([["text", region_3.Name], (elems_2 = [(el_13 = Text$, createElement(el_13, {
                children: region_3.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
        }, model.Regions))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (matchValue_1 == null) ? defaultOf_1() : matchValue_1),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_7 = [(el_23 = Field, createElement(el_23, createObj(toList(delay(() => append(singleton(["label", "Kommune"]), delay(() => append(patternInput_2[0] ? append(singleton(["validationMessage", "Kommune kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2;
        return singleton(["children", (matchValue_2 = tryHead_1([createElement(Component, {
            value: form.Municipality,
            onChange: (v_1) => {
                setForm(new NewWorkplace(form.Name, form.Enabled, form.RegionId, v_1));
                patternInput_2[1](isNullOrWhiteSpace(v_1));
            },
            placeholder: "Søk etter kommune...",
            disabled: false,
        })]), (matchValue_2 == null) ? defaultOf_1() : matchValue_2)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), (el_28 = Field, createElement(el_28, {
        label: "Aktiv",
        children: (matchValue_3 = tryHead_1([(el_25 = Switch, createElement(el_25, {
            checked: form.Enabled,
            onChange: (_arg_7, value_1_20) => {
                setForm(new NewWorkplace(form.Name, value_1_20.checked, form.RegionId, form.Municipality));
            },
        }))]), (matchValue_3 == null) ? defaultOf_1() : matchValue_3),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])))), (el_40 = DialogActions, createElement(el_40, createObj(ofArray([["position", "end"], ["style", {
        minWidth: 300,
        justifyContent: "end",
    }], (elems_10 = [(el_34 = Button, createElement(el_34, {
        icon: (el_32 = DismissRegular, createElement(el_32, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_8) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_38 = Button, createElement(el_38, {
        icon: (el_36 = AddRegular, createElement(el_36, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_9) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Workplace.AddWorkplace(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 0: {
                            errorToast(setCtx, "addWorkplaceRegionNotFound", "Kunne ikke legge til arbeidsplass", "Kunne ikke finne region", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, "addWorkplaceRegionMunicipalityEmpty", "Kunne ikke legge til arbeidsplass", "Kommune kan ikke være tomt", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, "addWorkplaceConflict", "Kunne ikke legge til arbeidsplass", "Det finnes allerede en arbeidsplass med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    dispatch(new Msg(0, [append_1([r], workplaces)]));
                    successToast(setCtx, `addWorkplace${r.Id}Success`, "Suksess", `${r.Name} ble lagt til`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name) ? true : (form.RegionId < 0),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])]))))]), (name_7 = DialogBody, createElement(name_7, {
        children: reactApi.Children.toArray(Array.from(props_58)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])]))))], (elemsToUse = ((length(elems_12) <= 2) ? elems_12 : take(2, elems_12)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditWorkplaceDialog(editWorkplaceDialogInputProps) {
    let elems_15, el_4, el_2, el, el_61, elems_14, props_90, el_6, el_49, elems_12, elems_1, el_11, elems_5, el_20, matchValue_1, el_17, elems_3, elems_7, el_23, el_28, matchValue_3, el_25, el_47, matchValue_5, el_44, elems_10, props_53, props_48, name_7, el_36, name_9, props_64, useTagPickerFilter, el_38, name_11, elemsToUse, el_59, elems_13, el_53, el_51, el_57, el_55, name_13, elemsToUse_1;
    const dispatch = editWorkplaceDialogInputProps.dispatch;
    const model = editWorkplaceDialogInputProps.model;
    const workplace = editWorkplaceDialogInputProps.workplace;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(workplace);
    const setForm = patternInput_2[1];
    const form = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const setQuery = patternInput_3[1];
    const query = patternInput_3[0];
    const dependencies = [workplace];
    reactApi.useEffect(() => {
        setForm(workplace);
    }, dependencies);
    const el_63 = Dialog;
    return createElement(el_63, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_15 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (el_61 = DialogSurface, createElement(el_61, createObj(ofArray([["style", {
        maxWidth: 400,
    }], (elems_14 = [(props_90 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: `Rediger ${workplace.Name}`,
    })), (el_49 = DialogContent, createElement(el_49, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_12 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(isNullOrWhiteSpace(form.Name) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead_1([(el_8 = Input, createElement(el_8, {
            maxLength: 100,
            value: form.Name,
            onChange: (_arg_2, value_1_8) => {
                setForm(new Workplace_1(form.Id, value_1_8.value, form.Enabled, form.Region, form.Municipality, form.Tracks));
            },
        }))]), (matchValue == null) ? defaultOf_1() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_5 = [(el_20 = Field, createElement(el_20, {
        label: "Region",
        children: (matchValue_1 = tryHead_1([(el_17 = Dropdown, createElement(el_17, createObj(ofArray([["style", {
            minWidth: 200,
        }], ["value", form.Region.Name], ["selectedOptions", toArray([form.Region.Name])], ["onOptionSelect", (_arg_3, value_1_12) => {
            iterate((region) => {
                setForm(new Workplace_1(form.Id, form.Name, form.Enabled, region, form.Municipality, form.Tracks));
            }, toArray_1(bind((name_2) => tryFind((r_1) => (r_1.Name === name_2), model.Regions), value_1_12.optionText)));
        }], (elems_3 = toList(delay(() => map_1((region_1) => {
            let elems_2, el_13;
            const el_15 = Option;
            return createElement(el_15, createObj(ofArray([["text", region_1.Name], (elems_2 = [(el_13 = Text$, createElement(el_13, {
                children: region_1.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
        }, model.Regions))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (matchValue_1 == null) ? defaultOf_1() : matchValue_1),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_7 = [(el_23 = Field, createElement(el_23, createObj(toList(delay(() => append(singleton(["label", "Kommune"]), delay(() => append(isNullOrWhiteSpace(form.Municipality) ? append(singleton(["validationMessage", "Kommune kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2;
        return singleton(["children", (matchValue_2 = tryHead_1([createElement(Component, {
            value: form.Municipality,
            onChange: (v_1) => {
                setForm(new Workplace_1(form.Id, form.Name, form.Enabled, form.Region, v_1, form.Tracks));
            },
            placeholder: "Søk etter kommune...",
            disabled: false,
        })]), (matchValue_2 == null) ? defaultOf_1() : matchValue_2)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), (el_28 = Field, createElement(el_28, {
        label: "Aktiv",
        children: (matchValue_3 = tryHead_1([(el_25 = Switch, createElement(el_25, {
            checked: form.Enabled,
            onChange: (_arg_4, value_1_18) => {
                setForm(new Workplace_1(form.Id, form.Name, value_1_18.checked, form.Region, form.Municipality, form.Tracks));
            },
        }))]), (matchValue_3 == null) ? defaultOf_1() : matchValue_3),
    })), (el_47 = Field, createElement(el_47, {
        label: "Læringsløp",
        style: {
            width: 100 + "%",
        },
        hint: "Tilgjengelige læringsløp for brukere med denne arbeidsplassen",
        children: (matchValue_5 = tryHead_1([(el_44 = TagPicker, createElement(el_44, createObj(ofArray([["onOptionSelect", (_arg_5, value_1_21) => {
            setForm(new Workplace_1(form.Id, form.Name, form.Enabled, form.Region, form.Municipality, model.Tracks.filter((t) => contains(t.Name, value_1_21.selectedOptions, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            }))));
            setQuery("");
        }], ["selectedOptions", toArray_2(ofArray(map_1((_arg_6) => _arg_6.Name, form.Tracks)))], (elems_10 = [(props_53 = ofArray([(props_48 = toList(delay(() => map_2((option_3) => {
            let el_30, elems_9, el_32;
            const el_34 = Tag;
            return createElement(el_34, createObj(ofArray([["key", option_3], ["shape", "rounded"], ["media", (el_30 = Avatar, createElement(el_30, {
                "aria-hidden": true,
                name: option_3,
                color: "colorful",
            }))], ["value", option_3], (elems_9 = [(el_32 = Text$, createElement(el_32, {
                children: option_3,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])));
        }, ofArray(map_1((_arg_7) => _arg_7.Name, form.Tracks))))), (name_7 = TagPickerGroup, createElement(name_7, {
            children: reactApi.Children.toArray(Array.from(props_48)),
        }))), (el_36 = TagPickerInput, createElement(el_36, {
            "aria-label": "Select tracks",
            value: query,
            onChange: (ev) => {
                setQuery(ev.target.value);
            },
        }))]), (name_9 = TagPickerControl, createElement(name_9, {
            children: reactApi.Children.toArray(Array.from(props_53)),
        }))), (props_64 = ((useTagPickerFilter = useTagPickerFilter_1, useTagPickerFilter({
            query: query,
            options: toArray_2(ofArray(map_1((_arg_8) => _arg_8.Name, model.Tracks))),
            noOptionsElement: (el_38 = TagPickerOption, createElement(el_38, {
                value: "Ingen resultat",
                children: "Fant ingen resultat",
            })),
            renderOption: (delegateArg) => {
                let el_40;
                const option_4 = delegateArg;
                const el_42 = TagPickerOption;
                return createElement(el_42, {
                    key: option_4,
                    media: (el_40 = Avatar, createElement(el_40, {
                        shape: "square",
                        "aria-hidden": true,
                        name: option_4,
                        color: "colorful",
                        value: option_4,
                    })),
                    value: option_4,
                    children: option_4,
                });
            },
            filter: (delegateArg_1) => {
                const option_5 = delegateArg_1;
                if (!contains(option_5, map_1((_arg_9) => _arg_9.Name, form.Tracks), {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: stringHash,
                })) {
                    return option_5.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) >= 0;
                }
                else {
                    return false;
                }
            },
        }))), (name_11 = TagPickerList, createElement(name_11, {
            children: reactApi.Children.toArray(Array.from(props_64)),
        })))], (elemsToUse = ((length(elems_10) <= 2) ? elems_10 : take(2, elems_10)), ["children", reactApi_1.Children.toArray(elemsToUse)]))]))))]), (matchValue_5 == null) ? defaultOf_1() : matchValue_5),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))), (el_59 = DialogActions, createElement(el_59, createObj(ofArray([["style", {
        minWidth: 300,
        justifyContent: "end",
    }], (elems_13 = [(el_53 = Button, createElement(el_53, {
        icon: (el_51 = DismissRegular, createElement(el_51, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_10) => {
            setIsOpen(false);
            setForm(workplace);
        },
    })), (el_57 = Button, createElement(el_57, {
        icon: (el_55 = SaveRegular, createElement(el_55, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_11) => {
            setIsOpen(false);
            const pr = tap((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 0: {
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}RegionNotFound`, "Kunne ikke oppdatere arbeidsplass", "Kunne ikke finne region", undefined);
                            break;
                        }
                        case 1: {
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}NotFound`, "Kunne ikke oppdatere arbeidsplass", "Kunne ikke finne arbeidsplass", undefined);
                            break;
                        }
                        case 3: {
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}MunicipalityEmpty`, "Kunne ikke oppdatere arbeidsplass", "Kommune kan ikke være tomt", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}Conflict`, "Kunne ikke oppdatere arbeidsplass", "Det finnes allerede en arbeidsplass med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    dispatch(new Msg(0, [map((array) => map_1((w) => {
                        if (w.Id === r.Id) {
                            return r;
                        }
                        else {
                            return w;
                        }
                    }, array), model.Workplaces)]));
                    successToast(setCtx, `updateWorkplace${r.Id}Success`, "Suksess", "Arbeidsplass ble oppdatert");
                }
            }, startAsPromise(Workplace.UpdateWorkplace(new UpdatedWorkplace(form.Id, form.Name, form.Enabled, form.Region.Id, form.Municipality, form.Tracks))));
            void (pr.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: ((((form.Name === workplace.Name) && (form.Enabled === workplace.Enabled)) && equals(form.Region, workplace.Region)) && (form.Municipality === workplace.Municipality)) && equalsWith(equals, form.Tracks, workplace.Tracks),
        children: "Lagre endringer",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))]), (name_13 = DialogBody, createElement(name_13, {
        children: reactApi.Children.toArray(Array.from(props_90)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])]))))], (elemsToUse_1 = ((length(elems_15) <= 2) ? elems_15 : take(2, elems_15)), ["children", reactApi_1.Children.toArray(elemsToUse_1)]))])));
}

function DeleteWorkplaceDialog(deleteWorkplaceDialogInputProps) {
    let elems_3, el_4, el_2, el, props_47, props_45, el_6, el_14, elems, el_20, elems_1, el_18, el_16, el_30, elems_2, name, name_2, elemsToUse;
    const dispatch = deleteWorkplaceDialogInputProps.dispatch;
    const model = deleteWorkplaceDialogInputProps.model;
    const workplace = deleteWorkplaceDialogInputProps.workplace;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const el_32 = Dialog;
    return createElement(el_32, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_47 = singleton_1((props_45 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Er du sikker?",
    })), (el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = toList(delay(() => {
        let el_8;
        return append(singleton((el_8 = WarningFilled, createElement(el_8, {
            primaryFill: tokens.colorStatusWarningForeground1,
            fontSize: 48,
        }))), delay(() => {
            let el_10;
            return append(singleton((el_10 = Body1Strong, createElement(el_10, {
                children: `Er du sikker på at du vil slette ${workplace.Name}? Det vil ikke være mulig å angre denne handlingen.`,
            }))), delay(() => {
                let el_12;
                return workplace.Enabled ? singleton((el_12 = Body1, createElement(el_12, {
                    children: "Du kan alternativt sette arbeidsplassen som inaktiv for å skjule den for brukere.",
                }))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "start"], (elems_1 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DismissRegular, createElement(el_16, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_1) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_30 = DialogActions, createElement(el_30, createObj(ofArray([["position", "end"], (elems_2 = toList(delay(() => {
        let el_24, el_22;
        return append(workplace.Enabled ? singleton((el_24 = Button, createElement(el_24, {
            icon: (el_22 = PenDismissRegular, createElement(el_22, {})),
            iconPosition: "before",
            children: "Sett inaktiv",
            onClick: (_arg_2) => {
                setIsOpen(false);
                let pr_3;
                const pr_2 = startAsPromise(Workplace.UpdateWorkplace(new UpdatedWorkplace(workplace.Id, workplace.Name, false, workplace.Region.Id, workplace.Municipality, workplace.Tracks)));
                pr_3 = (pr_2.then((res_1) => {
                    if (res_1.tag === 1) {
                        errorToast(setCtx, `DisableWorkplace${workplace.Id}Error`, "Kunne ikke oppdatere arbeidsplass", "Noe gikk galt", undefined);
                    }
                    else {
                        const r = res_1.fields[0];
                        dispatch(new Msg(0, [map((array_1) => map_1((w_1) => {
                            if (w_1.Id === r.Id) {
                                return r;
                            }
                            else {
                                return w_1;
                            }
                        }, array_1), model.Workplaces)]));
                        successToast(setCtx, `disableWorkplace${workplace.Id}Success`, "Suksess", `${workplace.Name} ble satt som inaktiv`);
                    }
                    return res_1;
                }));
                void (pr_3.catch((ex_1) => {
                    toastServerError(setCtx, ex_1);
                }));
            },
        }))) : empty(), delay(() => {
            let el_28, el_26;
            return singleton((el_28 = Button, createElement(el_28, {
                icon: (el_26 = DeleteRegular, createElement(el_26, {})),
                iconPosition: "before",
                appearance: "primary",
                children: "Slett",
                onClick: (_arg_3) => {
                    setIsOpen(false);
                    let pr_1;
                    const pr = startAsPromise(Workplace.DeleteWorkplace(workplace.Id));
                    pr_1 = (pr.then((res) => {
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 0) {
                                errorToast(setCtx, `DeleteWorkplace${workplace.Id}NotFound`, "Kunne ikke slette arbeidsplass", "Noe gikk galt", undefined);
                            }
                            else {
                                errorToast(setCtx, `DeleteWorkplace${workplace.Id}WithUsers`, "Kunne ikke slette arbeidsplass", "Arbeidsplasser som har brukere kan ikke slettes", undefined);
                            }
                        }
                        else {
                            dispatch(new Msg(0, [map((array) => array.filter((w) => (w.Id !== workplace.Id)), model.Workplaces)]));
                            successToast(setCtx, `deleteWorkplace${workplace.Id}Success`, "Suksess", `${workplace.Name} ble slettet`);
                        }
                        return res;
                    }));
                    void (pr_1.catch((ex) => {
                        toastServerError(setCtx, ex);
                    }));
                },
            })));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_45)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_47)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function Table(tableInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, createTableColumn_4, createTableColumn_5, tupledArg, elems_2, props_12, el_4, name_4, el_10;
    const dispatch = tableInputProps.dispatch;
    const model = tableInputProps.model;
    const workplaces = tableInputProps.workplaces;
    const patternInput = reactApi.useState(["name", new SortDirection(1, [])]);
    const columns = ofArray([(createTableColumn = createTableColumn_6, createTableColumn({
        columnId: "name",
        compare: (delegateArg, delegateArg_1) => compare(delegateArg.Name, delegateArg_1.Name),
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_3) => delegateArg_3.Name,
    })), (createTableColumn_1 = createTableColumn_6, createTableColumn_1({
        columnId: "enabled",
        compare: (delegateArg_4, delegateArg_1_1) => {
            const a_1 = delegateArg_4;
            const b_1 = delegateArg_1_1;
            if (a_1.Enabled && b_1.Enabled) {
                return 0;
            }
            else if (a_1.Enabled && !b_1.Enabled) {
                return -1;
            }
            else {
                return 1;
            }
        },
        renderHeaderCell: () => "Aktiv",
        renderCell: (delegateArg_6) => {
            if (delegateArg_6.Enabled) {
                const el = CheckmarkFilled;
                return createElement(el, {
                    primaryFill: tokens.colorStatusSuccessForeground1,
                });
            }
            else {
                const el_2 = DismissFilled;
                return createElement(el_2, {
                    primaryFill: tokens.colorStatusDangerForeground1,
                });
            }
        },
    })), (createTableColumn_2 = createTableColumn_6, createTableColumn_2({
        columnId: "region",
        compare: (delegateArg_7, delegateArg_1_2) => compare(delegateArg_7.Region.Name, delegateArg_1_2.Region.Name),
        renderHeaderCell: () => "Region",
        renderCell: (delegateArg_9) => delegateArg_9.Region.Name,
    })), (createTableColumn_3 = createTableColumn_6, createTableColumn_3({
        columnId: "municipality",
        compare: (delegateArg_10, delegateArg_1_3) => compare(delegateArg_10.Municipality, delegateArg_1_3.Municipality),
        renderHeaderCell: () => "Kommune",
        renderCell: (delegateArg_12) => delegateArg_12.Municipality,
    })), (createTableColumn_4 = createTableColumn_6, createTableColumn_4({
        columnId: "tracks",
        renderHeaderCell: () => "Læringsløp",
        compare: (delegateArg_14, delegateArg_1_4) => {
            const aLength = delegateArg_14.Tracks.length | 0;
            const bLength = delegateArg_1_4.Tracks.length | 0;
            if (aLength > bLength) {
                return 1;
            }
            else if (aLength < bLength) {
                return -1;
            }
            else {
                return 0;
            }
        },
        renderCell: (delegateArg_15) => (`${delegateArg_15.Tracks.length}`),
    })), (createTableColumn_5 = createTableColumn_6, createTableColumn_5({
        columnId: "edit",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_17) => {
            let elems;
            const workplace_5 = delegateArg_17;
            return createElement("div", createObj(singleton_1((elems = [createElement(EditWorkplaceDialog, {
                workplace: workplace_5,
                model: model,
                dispatch: dispatch,
            }), createElement(DeleteWorkplaceDialog, {
                workplace: workplace_5,
                model: model,
                dispatch: dispatch,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
        },
    }))]);
    const el_12 = DataGrid;
    return createElement(el_12, createObj(ofArray([dataGrid_items_Z6D8BD2B8(workplaces), ["columns", toArray(columns)], ["sortable", true], (tupledArg = patternInput[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_18, delegateArg_1_5) => {
        const sortState_1 = delegateArg_1_5;
        patternInput[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["getRowId", (delegateArg_19) => delegateArg_19.Id], (elems_2 = [(props_12 = singleton_1((el_4 = DataGridRow, createElement(el_4, {
        children: (delegateArg_20, delegateArg_1_6) => {
            const props_7 = singleton_1(delegateArg_20.renderHeaderCell());
            const name_2 = DataGridHeaderCell;
            return createElement(name_2, {
                children: reactApi.Children.toArray(Array.from(props_7)),
            });
        },
    }))), (name_4 = DataGridHeader, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_12)),
    }))), (el_10 = DataGridBody, createElement(el_10, {
        children: (delegateArg_22) => {
            const trd = delegateArg_22;
            const el_8 = DataGridRow;
            return createElement(el_8, {
                key: trd.rowId,
                children: (delegateArg_21, delegateArg_1_7) => {
                    let elems_1;
                    const tcd_1 = delegateArg_21;
                    const el_6 = DataGridCell;
                    return createElement(el_6, createObj(ofArray([["key", tcd_1.columnId], (elems_1 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

export function WorkplaceTable() {
    let elems_8, elems_1, el_28, elems_4, el_10, el_8, el_26, elems_3, el_16, el_14, el_12, el_24, elems_2, elemsToUse, el_38, elems_7;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        const pr = tap((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Noe gikk galt", "Kunne ikke hente arbeidsplasser", undefined);
                dispatch(new Msg(3, [false]));
            }
            else {
                dispatch(new Msg(0, [res.fields[0]]));
                dispatch(new Msg(3, [false]));
            }
        }, startAsPromise(Workplace.GetAllWorkplaces()));
        void (pr.catch((err) => {
            toastServerError(setCtx, err);
            dispatch(new Msg(3, [false]));
        }));
        const pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchRegionsError", "Noe gikk galt", "Kunne ikke hente regioner", undefined);
            }
            else {
                dispatch(new Msg(1, [res_1.fields[0]]));
            }
        }, startAsPromise(Region.GetAllRegions()));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        const pr_2 = tap((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "fetchTracksError", "Noe gikk galt", "Kunne ikke hente læringsløp", undefined);
            }
            else {
                dispatch(new Msg(2, [res_2.fields[0]]));
            }
        }, startAsPromise(Track.GetAll()));
        void (pr_2.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Arbeidsplasser",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Vis og administrer arbeidsplasser",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let el_6, el_4;
            const matchValue = model_1.Workplaces;
            if (matchValue != null) {
                const workplaces = matchValue;
                return singleton(createElement(AddWorkplaceDialog, {
                    workplaces: workplaces,
                    model: model_1,
                    dispatch: dispatch,
                }));
            }
            else {
                return singleton((el_6 = Button, createElement(el_6, {
                    icon: (el_4 = AddRegular, createElement(el_4, {})),
                    iconPosition: "before",
                    children: "Legg til",
                    appearance: "primary",
                    disabled: true,
                })));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_28 = Card, createElement(el_28, createObj(ofArray([["orientation", "horizontal"], ["style", {
        width: 100 + "%",
        display: "flex",
        justifyContent: "space-between",
    }], (elems_4 = [(el_10 = Input, createElement(el_10, {
        contentBefore: (el_8 = SearchRegular, createElement(el_8, {})),
        placeholder: "Søk etter arbeidsplass...",
        value: model_1.Filter.SearchTerm,
        onChange: (_arg_1, value_1_7) => {
            let bind$0040;
            const v = value_1_7;
            dispatch(new Msg(4, [(bind$0040 = model_1.Filter, new Filter(isNullOrWhiteSpace(v.value) ? "" : v.value, bind$0040.ShowOnlyEnabled, bind$0040.ShowOnlyFromRegions))]));
        },
    })), (el_26 = Popover, createElement(el_26, createObj(ofArray([["trapFocus", true], ["positioning", {
        position: "below",
        align: "end",
    }], (elems_3 = [(el_16 = PopoverTrigger, createElement(el_16, {
        children: (el_14 = Button, createElement(el_14, {
            icon: (el_12 = FilterRegular, createElement(el_12, {})),
            children: "Filter",
        })),
    })), (el_24 = PopoverSurface, createElement(el_24, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_2 = toList(delay(() => {
        let el_18;
        return append(singleton((el_18 = Checkbox, createElement(el_18, {
            label: "Vis kun aktive",
            checked: model_1.Filter.ShowOnlyEnabled,
            onChange: (_arg_2, c) => {
                let bind$0040_1;
                dispatch(new Msg(4, [(bind$0040_1 = model_1.Filter, new Filter(bind$0040_1.SearchTerm, Checkbox_toBool(c), bind$0040_1.ShowOnlyFromRegions))]));
            },
        }))), delay(() => {
            let el_20;
            return append(singleton((el_20 = Body1Strong, createElement(el_20, {
                children: "Regioner",
            }))), delay(() => map_1((region) => {
                const el_22 = Checkbox;
                return createElement(el_22, {
                    label: region.Name,
                    checked: contains(region.Id, model_1.Filter.ShowOnlyFromRegions, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: numberHash,
                    }),
                    onChange: (_arg_3, c_1) => {
                        let bind$0040_2;
                        dispatch(new Msg(4, [(bind$0040_2 = model_1.Filter, new Filter(bind$0040_2.SearchTerm, bind$0040_2.ShowOnlyEnabled, Checkbox_toBool(c_1) ? append_1(new Int32Array([region.Id]), model_1.Filter.ShowOnlyFromRegions, Int32Array) : model_1.Filter.ShowOnlyFromRegions.filter((y_1) => (region.Id !== y_1))))]));
                    },
                });
            }, model_1.Regions)));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_38 = Card, createElement(el_38, createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems_7 = toList(delay(() => {
        let el_32, elems_5, elems_6, el_34, el_36;
        const matchValue_2 = model_1.Workplaces;
        if (matchValue_2 != null) {
            let filteredWorkplaces;
            const array_5 = matchValue_2;
            filteredWorkplaces = array_5.filter((workplace) => applyFilter(model_1, workplace));
            return singleton(createElement(Table, {
                workplaces: filteredWorkplaces,
                model: model_1,
                dispatch: dispatch,
            }));
        }
        else {
            return model_1.IsFetchingWorkplaces ? singleton((el_32 = Skeleton, createElement(el_32, createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                width: 100 + "%",
            }], (elems_5 = toList(delay(() => map_2((_arg_4) => {
                const el_30 = SkeletonItem;
                return createElement(el_30, {
                    style: {
                        height: 48,
                    },
                    animation: "wave",
                    shape: "rectangle",
                });
            }, toList(rangeDouble(1, 1, 6))))), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 25,
            }], (elems_6 = [(el_34 = ErrorCircleRegular, createElement(el_34, {
                style: {
                    fontSize: 64 + "px",
                },
                primaryFill: tokens.colorBrandForeground1,
            })), (el_36 = Caption1, createElement(el_36, {
                children: "Kunne ikke hente arbeidsplasser. Vennligst prøv igjen senere",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

//# sourceMappingURL=Workplaces.jsx.map
